import {
  Flex,
  FlexColumn, ModelSelect,
} from '@equifinance/shared';
import { useMemo } from 'react';
import styled from 'styled-components';
import { formatDateTime } from '@equifinance/shared/utils';
import {
  SecurityCallStatus, useChecklistContext,
} from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';
import { DataInfo } from '../../common';

const SecuritySectionWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};;
  gap: ${theme.padding[5]};
`}`;

const ApplicantCallStatus = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[10]};
  align-items: end;
`}`;

const InputRow = styled(Flex)`
  width: 30%;
`;

export default function SecurityCallSection() {
  const { checklist } = useChecklistContext();

  const { sendOffer } = checklist ?? {};

  const { securityCall } = sendOffer ?? {};

  const securityCallIndices = useMemo(() => securityCall?.reduce((prev, current, index) => ({
    ...prev,
    [current.id]: index,
  }), {} as Record<string, number>), [securityCall]);

  return (
    <GenericSection
      id="security-call"
      subSection={ChecklistSection.SEND_OFFER_SECURITY_CALL}
      level={1}
    >
      <SecuritySectionWrapper>
        {securityCall?.map((sc, i) => (
          <ApplicantCallStatus key={sc.applicantId}>
            <InputRow>
              <ModelSelect
                required
                label={`Applicant ${i + 1} Call Status:`}
                placeholder="Select"
                field={`sendOffer.securityCall[${securityCallIndices?.[sc?.id]}].status`}
                options={SecurityCallStatus}
              />
            </InputRow>
            <Flex>
              <DataInfo label="Status Changed" value={sc.statusLastChangedDate && formatDateTime(sc.statusLastChangedDate, 'DD/MM/YYYY HH:mm:ss')} />
            </Flex>
          </ApplicantCallStatus>
        ))}
      </SecuritySectionWrapper>
    </GenericSection>
  );
}
